import React, { Component } from 'react';
import { connect } from 'react-redux';
import './login.scss';
import { Button } from 'antd';
import './signUpCategory.scss';
import logo from '../../../images/logo.png';
import { fromValidate, history } from '../../../helpers'
import { commonService } from '../service';


function SubCategoryList(props) {
    const subCategoryList = props.subCategoryList;

    const listItems = subCategoryList.map((subCategory) =>
        <div key={subCategory.id} className="checkbox-main">
            <input className='checkbox-container' type="checkbox"/>
            <label className="check-level-txt" for="vehicle1"> {subCategory.name}</label>
        </div> 
    );
    return (
      <ul>{listItems}</ul>
    );
  }

class Category extends Component {

	constructor(props) {
		super(props);
		this.state = {
			categories: [],
		}
    }
    

    componentDidMount = () => {
        commonService.getCategories()
        .then(response => {
         this.setState({
            categories :  response || []
        })

        },
          error => {
            console.log('not able to get categories');
        })

    }



	handleSubmit = () => {
		history.push('/application')
    }
    


	render() {
		const { user, formError, formSubmit, userNumber, isSuccess } = this.state;
		return (
			<div className='login-container overflow-css'>
				
				<div className='category-container'>
					<div className='category-box-logo reset-logo-right'>
						<img className='login-logo-image' src={logo}></img>
					</div>
					<div className="category-top-container">
                        <div className='txt-category'>What You Are Doing</div>
                        <div className="category-next-btn">
                            <Button htmlType="submit" className='btn-login'>NEXT</Button>
                        </div>
                    </div>
                    <div className="row category-container-scroll">
                        {
                            this.state.categories.map((category) => 

                            <div className="col-3">
                                <div className="tile-view">
                                    <div className="checkbox-main">
                                        <div className="catg-name">
                                            <div style={{height:'50px',width: '50px', borderRadius: '20px 0', position: 'absolute', left: '40px',top: "40px", margin: 'auto', backgroundColor: category.backgroundColor }}>
                                                <i class= {`fa ${category.icon} category-icon`} aria-hidden="true"></i>
                                            </div>
                                            <div className="signup-category-heading-txt">{category.name}</div>
                                        </div>
                                            <SubCategoryList subCategoryList={category.subcategory} />
                                    </div> 
                                </div>
                        </div>
                                
                            )
                        }

                    </div>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    return {
      user,
    }
  }
export default connect(mapStateToProps)(Category);